import React from "react";
import styled from "styled-components";
import SVG from "react-inlinesvg";
import { useSelector } from "react-redux";
import { calculateRemainingValue } from "../../../helpers/refund";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { Divider } from "@material-ui/core";
import FloatToCurrency from "../../../helpers/FloatToCurrency";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1rem 0;

  span {
    color: var(--fg-neutral-default);
    font-weight: 400;
    line-height: 1.25rem;

    strong {
      font-weight: 600;
    }
  }

  .desc-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
  }
`;

const WarningContainer = styled.div`
  display: flex;
  padding: 1rem 1.5rem;
  align-items: center;
  gap: 1rem;
  align-self: stretch;

  border-radius: var(--radius-large, 0.5rem);
  /* sem token border-warning-*: mistura do fg sobre o fundo (fallback p/ browser sem color-mix: a 2a declaração é inválida e cai; o cssnano apagaria um border duplicado, por isso border-color) */
  border: 1px solid var(--border-neutral-default);
  border-color: color-mix(in srgb, var(--fg-warning-stronger) 20%, var(--bg-warning-subtler));
  background: var(--bg-warning-subtler);
`;

const RefundInfo = ({ show = false, plans, selectedPlanId }) => {
  const subscription = useSelector(state => state.app.client_subscription.info);

  const { amount } = calculateRemainingValue(subscription);

  if (!show) {
    return <></>;
  }

  const plan = plans?.find(plan => plan.id === selectedPlanId);

  const iconPath = "/media/svg/icons/General/Warning.svg";
  const parsedAmount = `R$ ${FloatToCurrency(amount / 100)}`;
  const parsedNewValue = plan ? plan?.name?.split(" - ")[1] : "selecione um plano";

  return (
    <Container>
      <WarningContainer icon="flaticon-warning font-primary">
        <SVG
          src={toAbsoluteUrl(iconPath)}
        ></SVG>
        <span>
            Será realizado um estorno no valor de <strong>{parsedAmount}</strong> e uma nova cobrança será efetuada com o valor do novo plano e forma de pagamento escolhidos.
        </span>
      </WarningContainer>

      <div className='desc-item'>
        <span>Estorno</span>
        <span><strong>{parsedAmount}</strong></span>
      </div>

      <div className='desc-item'>
        <span>Nova cobrança</span>
        <span><strong>{parsedNewValue}</strong></span>
      </div>

      <Divider component="div" />
    </Container>
  );
};

export default RefundInfo;
